import { AutoSave } from './AutoSave.jsx';
import { SaveAndCloseButton, CloseButton } from './TileActionButtons.jsx';

import { LeftButton, RightButton } from './StyledComponents';

export const NewFormMenu = ({ onClose, onDiscard, autoSaved }) => {
  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <SaveAndCloseButton />
      </LeftButton>
      <AutoSave autoSaved={autoSaved} />
      <RightButton mode="outline" onClick={onDiscard} variant="black">
        <CloseButton />
      </RightButton>
    </>
  );
};
